var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-32"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.13,
    y: 299.55,
    width: 6.1,
    height: 81.96,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.13,
    y: 299.55,
    width: 6.1,
    height: 81.96,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.92,
    y: 317.22,
    width: 6.1,
    height: 110.42,
    transform: "translate(745.4 -0.54) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.92,
    y: 277.22,
    width: 6.1,
    height: 110.42,
    transform: "translate(705.4 -40.54) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.69,358.13c0-.74-9-.16-9-.16s-5.55,5.64-10.94,6.91-2.38,4.5,3.65,4.5h14.9C401.54,369.38,398.87,365.74,398.69,358.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.11,360.06a.85.85,0,0,1-.22-1,1,1,0,0,1,.48-.61,3.59,3.59,0,0,1,2-.22c-.73-.4-1.37-.87-1.4-1.35,0-.3.18-.56.59-.75a1.37,1.37,0,0,1,1.17,0c1.22.51,2,2.62,2,2.71a.19.19,0,0,1,0,.18s0,0,0,.05h0a.16.16,0,0,1-.08.06,11.18,11.18,0,0,1-3.74,1.15A1.26,1.26,0,0,1,384.11,360.06Zm.5-1.16a.49.49,0,0,0-.26.31c-.09.36,0,.45.06.48.43.35,2.08-.15,3.41-.71C386.8,358.76,385.26,358.53,384.61,358.9Zm1.18-2.3c-.13,0-.33.17-.32.3,0,.4,1.31,1.1,2.65,1.61a4.08,4.08,0,0,0-1.55-1.94,1,1,0,0,0-.37-.07A.91.91,0,0,0,385.79,356.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.23,358.26c0-.73-9-.16-9-.16s-5.55,5.65-10.94,6.91-2.38,4.51,3.65,4.51h14.9C423.08,369.52,420.41,365.87,420.23,358.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.65,360.19a.84.84,0,0,1-.22-1,1,1,0,0,1,.48-.61,3.78,3.78,0,0,1,2-.22c-.73-.39-1.37-.87-1.4-1.34,0-.31.18-.56.59-.76a1.41,1.41,0,0,1,1.17,0c1.22.51,2,2.61,2,2.7a.19.19,0,0,1,0,.18.09.09,0,0,1,0,.06h0l-.08.06a11.44,11.44,0,0,1-3.74,1.14A1.2,1.2,0,0,1,405.65,360.19Zm.5-1.16a.51.51,0,0,0-.26.32c-.09.35,0,.44.06.48.43.35,2.08-.15,3.41-.71C408.34,358.89,406.8,358.66,406.15,359Zm1.18-2.3c-.13.06-.33.18-.32.3,0,.41,1.31,1.11,2.65,1.62a4,4,0,0,0-1.55-1.94,1,1,0,0,0-.37-.08A.88.88,0,0,0,407.33,356.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.77,328.4a10.55,10.55,0,0,1,3.42-1.86h0s3.72-3.69,5.51-14.8l4.87-1.27A4.13,4.13,0,0,1,415,312.2a2.11,2.11,0,0,1,.31.64,27.29,27.29,0,0,1,.52,3.61c.49,3.76.07,12.2.07,12.2H415l-.35-7.66c-.13-2.6-2.12.45-2.69,3.25s-1.78,5.78-7.48,5.92C397.85,330.29,395.09,330,396.77,328.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.21,328.4a10.55,10.55,0,0,1,3.42-1.86h0s3.72-3.69,5.51-14.8l4.87-1.27a4.13,4.13,0,0,1,4.43,1.73,2.11,2.11,0,0,1,.31.64,27.29,27.29,0,0,1,.52,3.61c.49,3.76.07,12.2.07,12.2h-.88l-.35-7.66c-.13-2.6-2.12.45-2.69,3.25s-1.78,5.78-7.48,5.92C376.29,330.29,373.53,330,375.21,328.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.35,368.48a10.55,10.55,0,0,1,3.42-1.86h0s3.72-3.69,5.51-14.8l4.87-1.27a4.14,4.14,0,0,1,4.43,1.73,2.11,2.11,0,0,1,.31.64,27.29,27.29,0,0,1,.52,3.61c.49,3.76.07,12.2.07,12.2h-.88l-.35-7.66c-.13-2.6-2.12.45-2.69,3.25s-1.78,5.78-7.48,5.92C351.43,370.37,348.67,370.11,350.35,368.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.79,368.48a10.55,10.55,0,0,1,3.42-1.86h0s3.72-3.69,5.51-14.8l4.87-1.27a4.14,4.14,0,0,1,4.43,1.73,2.11,2.11,0,0,1,.31.64,27.29,27.29,0,0,1,.52,3.61c.49,3.76.07,12.2.07,12.2H347l-.35-7.66c-.13-2.6-2.12.45-2.69,3.25s-1.78,5.78-7.48,5.92C329.87,370.37,327.11,370.11,328.79,368.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.19,316.2a2,2,0,0,0-.21-.56c-3.62-.77-6.53,7.22-8.32,9.46s-5.31,1.25-5.31,1.25a9.14,9.14,0,0,0-3,1.26c-1.55,1.22.74,1.68,6.31,2.15,4.78.37,6.05-2,6.77-4.31s2.65-4.67,2.54-2.48l-.38,6.44.74.07a85.09,85.09,0,0,0,1-10.21A24.25,24.25,0,0,0,372.19,316.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.19,316.2a2,2,0,0,0-.21-.56c-3.62-.77-6.53,7.22-8.32,9.46s-5.31,1.25-5.31,1.25a9.14,9.14,0,0,0-3,1.26c-1.55,1.22.74,1.68,6.31,2.15,4.78.37,6.05-2,6.77-4.31s2.65-4.67,2.54-2.48l-.38,6.44.74.07a85.09,85.09,0,0,0,1-10.21A24.25,24.25,0,0,0,353.19,316.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.07 284.51 241.07 381.51 235.07 381.51 235.07 296.51 129.07 296.51 129.07 381.51 122.07 381.51 122.07 284.51 241.07 284.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.07 284.51 175.07 381.51 169.07 381.51 169.07 296.51 63.07 296.51 63.07 381.51 56.07 381.51 56.07 284.51 175.07 284.51",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.33,242.56a6.1,6.1,0,0,1,3.91,3.94,8.55,8.55,0,0,0,7.47,5.27,5.7,5.7,0,0,1,3,1l.94.54c0-.33-.08-.67-.1-1-.26-.21-.52-.42-.77-.65l-.17-.17c-2.94-2.82-3-5.8-6.45-8.47S63.33,242.56,63.33,242.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.85,239.61a6.07,6.07,0,0,0-3.32,4.46,8.53,8.53,0,0,1-6.65,6.26,5.66,5.66,0,0,0-2.81,1.46l-.85.67c0-.33,0-.68-.06-1a10,10,0,0,0,.68-.75l.15-.19c2.51-3.21,2.17-6.16,5.19-9.3S91.85,239.61,91.85,239.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.07,251.79a18.79,18.79,0,0,1-.58,5.52c-1.65,6.42-.91.1-.91.1a16.38,16.38,0,0,0,.64-5c0-.33,0-.68-.06-1a14.93,14.93,0,0,0-.77-3.74c-1.74-5-5.22-6.6-6.6-12s3.39-9.26,3.39-9.26a7.68,7.68,0,0,0,2.57,6.51c3.21,3.12,3.67,8.53,2.29,11.28-.8,1.6-.29,3.61-.05,6.28C79,250.91,79.05,251.34,79.07,251.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.84 284.51 83.05 262.82 84.12 256.51 72.19 256.51 73.26 262.82 69.48 284.51 86.84 284.51",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.38,
    y: 82.31,
    width: 130.13,
    height: 143.99,
    style: {
      fill: "#e9e9e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.11,
    y: 88.02,
    width: 119.02,
    height: 132.88,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.75 88.02 303.11 213.99 303.11 145.79 318.5 88.02 336.75 88.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.78 88.02 316.31 220.9 309.62 220.9 345.09 88.02 351.78 88.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.13 124.25 422.13 192.46 414.59 220.9 396.35 220.9 422.13 124.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.14,
    y: 82.31,
    width: 4.62,
    height: 143.99,
    style: {
      fill: "#e9e9e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.64,
    y: 111.53,
    width: 125.37,
    height: 4.62,
    style: {
      fill: "#e9e9e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,98.72a23.56,23.56,0,1,0,23.56-23.55A23.55,23.55,0,0,0,129,98.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.51,98.72a20,20,0,1,0,20-20A20,20,0,0,0,132.51,98.72Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "153.48 84.98 153.48 98.98 162.76 93.73",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.48,100a1,1,0,0,1-1-1V85a1,1,0,1,1,2,0V97.27l7.79-4.41a1,1,0,1,1,1,1.74L154,99.85A1,1,0,0,1,153.48,100Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-32"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-32",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.21,343.85c.21,1.47-3.78,2.44-7,3,.27,2.67,2,5.36,4.5,7.88,3.08-1.74,7.49-4,8.3-3.47s-3.63,3.53-6.45,5.24a59,59,0,0,0,6.39,4.84c1.39-1.29,3-2.42,4-1.81s.73,2.64.24,4.42c3.35,2,5.87,3.15,5.87,3.15a69.18,69.18,0,0,0,2.24-9.53c-.17-.34-.34-.67-.49-1-.54-1.25,0-1.79.88-2a33.61,33.61,0,0,0,.05-6.87c-3.8-.79-8.42-2.27-6.69-4.55,1.05-1.37,3-1.53,4.94-1.18a7.9,7.9,0,0,0-.93-1.28c-6.92-7.62-11.74,0-11.74,0-4-3.35-9.66-2.44-10.88,2.79C108.63,342.89,113,342,113.21,343.85Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.21,343.85c.21,1.47-3.78,2.44-7,3,.27,2.67,2,5.36,4.5,7.88,3.08-1.74,7.49-4,8.3-3.47s-3.63,3.53-6.45,5.24a59,59,0,0,0,6.39,4.84c1.39-1.29,3-2.42,4-1.81s.73,2.64.24,4.42c3.35,2,5.87,3.15,5.87,3.15a69.18,69.18,0,0,0,2.24-9.53c-.17-.34-.34-.67-.49-1-.54-1.25,0-1.79.88-2a33.61,33.61,0,0,0,.05-6.87c-3.8-.79-8.42-2.27-6.69-4.55,1.05-1.37,3-1.53,4.94-1.18a7.9,7.9,0,0,0-.93-1.28c-6.92-7.62-11.74,0-11.74,0-4-3.35-9.66-2.44-10.88,2.79C108.63,342.89,113,342,113.21,343.85Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.84,399.83l-1-.08c0-.51,4.09-51.52-7.35-56.33a3.88,3.88,0,0,0-3.47.08c-4.14,2.16-6.12,11.09-6.14,11.18l-1-.22c.08-.38,2.1-9.47,6.65-11.84a4.89,4.89,0,0,1,4.32-.12C126,347.58,122,397.7,121.84,399.83Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.28,398.73c-.2-2.3-4.88-56.27,3.86-62,2.1-1.37,4-1.67,5.55-.86,4.13,2.08,4.67,10.91,4.69,11.28l-1,.06c0-.09-.53-8.63-4.15-10.45-1.24-.63-2.77-.36-4.55.81-8.24,5.4-3.46,60.51-3.41,61.07Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.59,403.09c-.06-1.76-1.5-43.07,6.46-46.69a5.59,5.59,0,0,1,4.73,0c5.46,2.4,8.83,12.57,9,13l-.95.31c0-.11-3.37-10.19-8.42-12.41a4.6,4.6,0,0,0-3.92,0c-6.1,2.78-6.3,34-5.87,45.74Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.57,401.2l-1-.11c1.4-12.3,4.08-45.06-.3-49a1.72,1.72,0,0,0-1.79-.55c-2.94,1.12-4.72,11.78-5.17,15.79l-1-.11c.17-1.54,1.77-15.07,5.8-16.62a2.66,2.66,0,0,1,2.81.74C127.6,356.42,122.78,399.38,122.57,401.2Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.88 377.89 141.81 377.89 138.81 418.14 108.88 418.14 105.88 377.89",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.79 377.89 117.79 418.13 138.81 418.13 141.81 377.89 116.79 377.89",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.78,363.12c-.38,1-3.17.21-5.36-.57-.75,1.74-.58,4,.07,6.41,2.5,0,6,.07,6.31.7s-3.45.93-5.77,1a40.05,40.05,0,0,0,2.28,5.18c1.29-.32,2.68-.47,3.07.24s-.46,1.88-1.37,2.81c1.39,2.36,2.54,3.95,2.54,3.95a48.12,48.12,0,0,0,4.65-5.11c0-.26,0-.53,0-.8.09-1,.6-1.11,1.21-.91a23.9,23.9,0,0,0,2.39-4.21c-2.07-1.8-4.42-4.29-2.57-5.1,1.12-.49,2.35.07,3.46,1a6.74,6.74,0,0,0-.14-1.11c-1.66-7.07-7.24-4-7.24-4-1.33-3.44-5.12-4.82-7.67-2C108.28,361,111.24,361.92,110.78,363.12Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.78,363.12c-.38,1-3.17.21-5.36-.57-.75,1.74-.58,4,.07,6.41,2.5,0,6,.07,6.31.7s-3.45.93-5.77,1a40.05,40.05,0,0,0,2.28,5.18c1.29-.32,2.68-.47,3.07.24s-.46,1.88-1.37,2.81c1.39,2.36,2.54,3.95,2.54,3.95a48.12,48.12,0,0,0,4.65-5.11c0-.26,0-.53,0-.8.09-1,.6-1.11,1.21-.91a23.9,23.9,0,0,0,2.39-4.21c-2.07-1.8-4.42-4.29-2.57-5.1,1.12-.49,2.35.07,3.46,1a6.74,6.74,0,0,0-.14-1.11c-1.66-7.07-7.24-4-7.24-4-1.33-3.44-5.12-4.82-7.67-2C108.28,361,111.24,361.92,110.78,363.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.45,367.9a14.5,14.5,0,0,0-3.28.69,7.65,7.65,0,0,1-.49-2.37c-.22-7.25,5-4.19,7.7-6.32a5.88,5.88,0,0,1,4.59-1.44,11,11,0,0,0-.62,1.24,1.13,1.13,0,0,0,.88,1.55,3.29,3.29,0,0,0,2-.24,4.8,4.8,0,0,0,.52-.36,9.33,9.33,0,0,1,1,2.42,14.08,14.08,0,0,1,.47,3.1,10.37,10.37,0,0,0-1.21.34,1.13,1.13,0,0,0-.46,1.72,5.15,5.15,0,0,0,1.5,1,17,17,0,0,1-.91,3.4l-.37.05c-.27.06-.53.12-.79.2a3.66,3.66,0,0,0-.43.15,1.18,1.18,0,0,0-.68.88,1.14,1.14,0,0,0,.43,1.05,3.71,3.71,0,0,0,.54.33,8,8,0,0,1-2.87,2.9,31.08,31.08,0,0,1-3.05-1.61c.21-.3.43-.59.63-.88a1.74,1.74,0,0,0,.31-1.14,1.53,1.53,0,0,0-1.73-1.33,1.54,1.54,0,0,0-1,.58c-.24.36-.5.7-.77,1a19.11,19.11,0,0,1-3.68-3.57l.11,0a11,11,0,0,1,2-.34,1.54,1.54,0,1,0-.4-3.06Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.45,367.9a14.5,14.5,0,0,0-3.28.69,7.65,7.65,0,0,1-.49-2.37c-.22-7.25,5-4.19,7.7-6.32a5.88,5.88,0,0,1,4.59-1.44,11,11,0,0,0-.62,1.24,1.13,1.13,0,0,0,.88,1.55,3.29,3.29,0,0,0,2-.24,4.8,4.8,0,0,0,.52-.36,9.33,9.33,0,0,1,1,2.42,14.08,14.08,0,0,1,.47,3.1,10.37,10.37,0,0,0-1.21.34,1.13,1.13,0,0,0-.46,1.72,5.15,5.15,0,0,0,1.5,1,17,17,0,0,1-.91,3.4l-.37.05c-.27.06-.53.12-.79.2a3.66,3.66,0,0,0-.43.15,1.18,1.18,0,0,0-.68.88,1.14,1.14,0,0,0,.43,1.05,3.71,3.71,0,0,0,.54.33,8,8,0,0,1-2.87,2.9,31.08,31.08,0,0,1-3.05-1.61c.21-.3.43-.59.63-.88a1.74,1.74,0,0,0,.31-1.14,1.53,1.53,0,0,0-1.73-1.33,1.54,1.54,0,0,0-1,.58c-.24.36-.5.7-.77,1a19.11,19.11,0,0,1-3.68-3.57l.11,0a11,11,0,0,1,2-.34,1.54,1.54,0,1,0-.4-3.06Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.52,342.92a10.15,10.15,0,0,1,2-1.08,5.31,5.31,0,0,0-.79-1.46c-3.06-3.91-4.44,0-6.81.06a4,4,0,0,0-3,1.26,8.2,8.2,0,0,1,.87.38.78.78,0,0,1,.21,1.2,2.2,2.2,0,0,1-1.17.76,2.09,2.09,0,0,1-.43,0,6.64,6.64,0,0,0,.54,1.71,9.38,9.38,0,0,0,1.11,1.84,5.63,5.63,0,0,1,.79-.36.78.78,0,0,1,1,.71,3.87,3.87,0,0,1-.32,1.21,11.86,11.86,0,0,0,2,1.38l.21-.13c.17-.09.33-.17.5-.24a1.82,1.82,0,0,1,.3-.11.77.77,0,0,1,1,.9c0,.14-.09.28-.14.41a5.48,5.48,0,0,0,2.78.26,20,20,0,0,0,.89-2.18l-.72-.19a1.15,1.15,0,0,1-.66-.46,1.07,1.07,0,0,1-.14-.8,1.05,1.05,0,0,1,1.26-.8c.28.08.57.15.86.21A13,13,0,0,0,142,344l-.07,0a7.11,7.11,0,0,0-1.22.72,1.06,1.06,0,0,1-1.14-1.78Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.52,342.92a10.15,10.15,0,0,1,2-1.08,5.31,5.31,0,0,0-.79-1.46c-3.06-3.91-4.44,0-6.81.06a4,4,0,0,0-3,1.26,8.2,8.2,0,0,1,.87.38.78.78,0,0,1,.21,1.2,2.2,2.2,0,0,1-1.17.76,2.09,2.09,0,0,1-.43,0,6.64,6.64,0,0,0,.54,1.71,9.38,9.38,0,0,0,1.11,1.84,5.63,5.63,0,0,1,.79-.36.78.78,0,0,1,1,.71,3.87,3.87,0,0,1-.32,1.21,11.86,11.86,0,0,0,2,1.38l.21-.13c.17-.09.33-.17.5-.24a1.82,1.82,0,0,1,.3-.11.77.77,0,0,1,1,.9c0,.14-.09.28-.14.41a5.48,5.48,0,0,0,2.78.26,20,20,0,0,0,.89-2.18l-.72-.19a1.15,1.15,0,0,1-.66-.46,1.07,1.07,0,0,1-.14-.8,1.05,1.05,0,0,1,1.26-.8c.28.08.57.15.86.21A13,13,0,0,0,142,344l-.07,0a7.11,7.11,0,0,0-1.22.72,1.06,1.06,0,0,1-1.14-1.78Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.25,350.17c-.21,1.47,3.78,2.44,7,3-.27,2.67-2,5.37-4.49,7.89-3.09-1.74-7.49-4-8.31-3.48s3.63,3.53,6.45,5.25a58,58,0,0,1-6.39,4.84c-1.38-1.3-3-2.43-4-1.82s-.73,2.64-.23,4.42c-3.36,2-5.87,3.15-5.87,3.15a67.5,67.5,0,0,1-2.24-9.53c.16-.33.33-.67.49-1,.54-1.25,0-1.78-.88-2a33.53,33.53,0,0,1-.06-6.86c3.8-.8,8.42-2.27,6.69-4.55-1-1.38-3-1.53-4.94-1.19a8,8,0,0,1,.94-1.28c6.91-7.61,11.73,0,11.73,0,4-3.34,9.67-2.44,10.89,2.79C114.83,349.22,110.51,348.36,110.25,350.17Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.25,350.17c-.21,1.47,3.78,2.44,7,3-.27,2.67-2,5.37-4.49,7.89-3.09-1.74-7.49-4-8.31-3.48s3.63,3.53,6.45,5.25a58,58,0,0,1-6.39,4.84c-1.38-1.3-3-2.43-4-1.82s-.73,2.64-.23,4.42c-3.36,2-5.87,3.15-5.87,3.15a67.5,67.5,0,0,1-2.24-9.53c.16-.33.33-.67.49-1,.54-1.25,0-1.78-.88-2a33.53,33.53,0,0,1-.06-6.86c3.8-.8,8.42-2.27,6.69-4.55-1-1.38-3-1.53-4.94-1.19a8,8,0,0,1,.94-1.28c6.91-7.61,11.73,0,11.73,0,4-3.34,9.67-2.44,10.89,2.79C114.83,349.22,110.51,348.36,110.25,350.17Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.08,
    y: 112.58,
    width: 213.18,
    height: 154.64,
    rx: 6.62,
    transform: "translate(381.33 379.81) rotate(180)",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.25,119.2V260.61a6.61,6.61,0,0,1-6.61,6.61H90.69a6.61,6.61,0,0,1-6.61-6.61V119.2a6.61,6.61,0,0,1,6.61-6.62h200A6.61,6.61,0,0,1,297.25,119.2Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.89,261.37a10,10,0,0,1,0-20h38.18a10,10,0,0,1,0,20Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,242.38H242.89a9,9,0,0,0,0,18h38.18a9,9,0,0,0,0-18Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.16,251a2.56,2.56,0,0,1,2.68-2.59,2.49,2.49,0,0,1,1.92.79l-.47.46a1.85,1.85,0,0,0-1.42-.6,1.94,1.94,0,1,0,1.42,3.27l.47.45a2.51,2.51,0,0,1-1.93.8A2.55,2.55,0,0,1,247.16,251Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.88,252.23H253.2l-.56,1.26h-.74l2.29-5.05h.71l2.29,5.05h-.75Zm-.25-.58-1.09-2.47-1.09,2.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.28,248.44v5.05h-.59l-3-3.76v3.76h-.72v-5.05h.59l3,3.77v-3.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.38,251a2.55,2.55,0,0,1,2.67-2.59,2.49,2.49,0,0,1,1.92.79l-.47.46a1.83,1.83,0,0,0-1.42-.6,1.94,1.94,0,1,0,0,3.88,1.88,1.88,0,0,0,1.42-.61l.47.45a2.5,2.5,0,0,1-1.92.8A2.55,2.55,0,0,1,263.38,251Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.66,252.86v.63H269v-5.05h3.56v.63h-2.84v1.55h2.53v.61h-2.53v1.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.83,248.44h.72v4.42h2.73v.63h-3.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.34,260.37H184.17a9,9,0,0,1-9-9h0a9,9,0,0,1,9-9h38.17a9,9,0,0,1,9,9h0A9,9,0,0,1,222.34,260.37Z",
    style: {
      fill: "#FF822F",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.77,251a2.55,2.55,0,0,1,2.67-2.59,2.49,2.49,0,0,1,1.92.79l-.47.46a1.83,1.83,0,0,0-1.42-.6,1.94,1.94,0,1,0,0,3.88,1.88,1.88,0,0,0,1.42-.61l.47.45a2.51,2.51,0,0,1-1.93.8A2.55,2.55,0,0,1,183.77,251Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.87,251a2.68,2.68,0,1,1,2.69,2.58A2.57,2.57,0,0,1,188.87,251Zm4.64,0a2,2,0,1,0-1.95,1.94A1.89,1.89,0,0,0,193.51,251Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.67,248.44v5.05h-.59l-3-3.76v3.76h-.72v-5.05h.59l3,3.77v-3.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.19,249.07h-1.73v-.63h4.17v.63H202.9v4.42h-.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.41,248.44h.73v5.05h-.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,248.44v5.05h-.59l-3-3.76v3.76h-.72v-5.05h.59l3,3.77v-3.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.46,251.31v-2.87h.72v2.84c0,1.12.51,1.63,1.42,1.63s1.43-.51,1.43-1.63v-2.84h.7v2.87a2.14,2.14,0,1,1-4.27,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.86,252.86v.63H219.2v-5.05h3.56v.63h-2.84v1.55h2.53v.61h-2.53v1.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 180.7,
    width: 196.06,
    height: 12.95,
    rx: 0.83,
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.08,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.79,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.26,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.72,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.18,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.65,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.11,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.58,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.04,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.51,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.97,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.43,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.9,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.36,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.33,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.86,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.4,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.93,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.47,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.01,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.54,
    y: 182.76,
    width: 4.75,
    height: 8.83,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.39,170.27H96.17A2.18,2.18,0,0,0,94,172.45h0a2.17,2.17,0,0,0,2.17,2.17h31.22a2.17,2.17,0,0,0,2.17-2.17h0A2.18,2.18,0,0,0,127.39,170.27Z",
    style: {
      fill: "#FF822F",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.25,119.2v16.24H84.08V119.2a6.61,6.61,0,0,1,6.61-6.62h200A6.61,6.61,0,0,1,297.25,119.2Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.76,124.36a3.43,3.43,0,1,1-3.43-3.43A3.43,3.43,0,0,1,291.76,124.36Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.76,124.36a3.43,3.43,0,1,1-3.43-3.43A3.43,3.43,0,0,1,281.76,124.36Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.76,124.36a3.43,3.43,0,1,1-3.43-3.43A3.43,3.43,0,0,1,271.76,124.36Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.08,
    y: 135.44,
    width: 213.17,
    height: 26.09,
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.39,142.27H96.17A2.18,2.18,0,0,0,94,144.45h0a2.17,2.17,0,0,0,2.17,2.17H197.39a2.17,2.17,0,0,0,2.17-2.17h0A2.18,2.18,0,0,0,197.39,142.27Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.39,151.27H96.17A2.18,2.18,0,0,0,94,153.45h0a2.17,2.17,0,0,0,2.17,2.17h71.22a2.17,2.17,0,0,0,2.17-2.17h0A2.18,2.18,0,0,0,167.39,151.27Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.97,
    y: 142.27,
    width: 22.09,
    height: 13.34,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 201,
    width: 194.76,
    height: 32.3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.37,204.27H99.54A1.54,1.54,0,0,0,98,205.82h0a1.53,1.53,0,0,0,1.54,1.54h71.83a1.54,1.54,0,0,0,1.54-1.54h0A1.54,1.54,0,0,0,171.37,204.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.08,211.4H99.54A1.53,1.53,0,0,0,98,212.94h0a1.53,1.53,0,0,0,1.54,1.54h50.54a1.54,1.54,0,0,0,1.54-1.54h0A1.54,1.54,0,0,0,150.08,211.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.08,218.53H99.54A1.53,1.53,0,0,0,98,220.07h0a1.53,1.53,0,0,0,1.54,1.54H200.08a1.54,1.54,0,0,0,1.54-1.54h0A1.54,1.54,0,0,0,200.08,218.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.08,225.66H99.54A1.53,1.53,0,0,0,98,227.2h0a1.53,1.53,0,0,0,1.54,1.54h40.54a1.54,1.54,0,0,0,1.54-1.54h0A1.54,1.54,0,0,0,140.08,225.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.89,
    y: 201,
    width: 3.87,
    height: 32.3,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.89,
    y: 201,
    width: 3.87,
    height: 10.97,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.39,122.27H96.17A2.18,2.18,0,0,0,94,124.45h0a2.17,2.17,0,0,0,2.17,2.17h31.22a2.17,2.17,0,0,0,2.17-2.17h0A2.18,2.18,0,0,0,127.39,122.27Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.25,135.44v26.09H201c13.24-13.73,31.9-21.68,46.32-26.09Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.36,296H309.9a8.83,8.83,0,0,0-8.83,8.83l-12,76.47H415.19l12-76.47A8.84,8.84,0,0,0,418.36,296Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.36,296H309.9a8.83,8.83,0,0,0-8.83,8.83l-12,76.47H415.19l12-76.47A8.84,8.84,0,0,0,418.36,296Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.52,382.39h17.67l12-77.6a8.84,8.84,0,0,0-8.84-8.83h0a8.83,8.83,0,0,0-8.83,8.83Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.38,325.53H247.52l-.45,0a10.77,10.77,0,0,0-10.77,10.78v81.85h63.22V336.29A10.62,10.62,0,0,0,289.38,325.53Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.38,325.53H247.52l-.45,0a10.77,10.77,0,0,0-10.77,10.78v81.85h63.22V336.29A10.62,10.62,0,0,0,289.38,325.53Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.07,325.51h0a10.77,10.77,0,0,0-10.77,10.78v81.85h21.55V336.29A10.77,10.77,0,0,0,247.07,325.51Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.89,
    y: 352.64,
    width: 92.41,
    height: 65.5,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.89,
    y: 352.64,
    width: 92.41,
    height: 65.5,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.86,368.64H270.91a11.36,11.36,0,0,1-11.36-11.36h0a11.36,11.36,0,0,1,11.36-11.36h104Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.86,368.64H270.91a11.36,11.36,0,0,1-11.36-11.36h0a11.36,11.36,0,0,1,11.36-11.36h104Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.35,317.52l29.35,7.91c2.25-7.77,6.59-21.49,11.05-30.36,1.43-2.87,3.14-6.05,5.23-9.7,1.12-1.95,2.34-4,3.68-6.28,1-1.7,2.1-3.51,3.28-5.41a97,97,0,0,0-12.46-6.1,103.24,103.24,0,0,0-13.91-4.66c-6.16-1.42-13.41-2.3-13.41-2.3s-1.06,0-3.15,6.42C333.07,273.05,329,294.89,325.35,317.52Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.13,319c4.76-4.07,17-.61,18.75-.07l1.24-7.09.27-1.54,32,2.47c.26.61.52,1.22.77,1.84.56,1.38,1.07,2.79,1.55,4.2,13.66,0,21.29,8.46,18.17,17.74-3.5,10.39-13.12,21.21-25.28,21.21a18.14,18.14,0,0,1-7.09-1.37,23.88,23.88,0,0,0-15.31-.67,24.52,24.52,0,0,1-10.22.06C288.11,350.63,296.62,324.56,303.13,319Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,314.38a1.62,1.62,0,1,1-1.61-1.62A1.62,1.62,0,0,1,336,314.38Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.41,311.52l-.4,3.74a.77.77,0,0,1-.82.68l-5-.4a.75.75,0,0,1-.69-.83l.35-3.68a.76.76,0,0,1,.81-.69l5,.34A.77.77,0,0,1,337.41,311.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.76 311.97 346.16 316.37 347.39 316.37 347.2 311.97 345.76 311.97",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.81 310.63 327.32 315.24 326.18 315.24 326.58 310.44 327.81 310.63",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,355.77a24.48,24.48,0,0,0,10.21-.06,23.94,23.94,0,0,1,15.31.66,18,18,0,0,0,7.1,1.38c12.16,0,21.78-10.82,25.27-21.21a12.21,12.21,0,0,0,.52-6.05L338,336.29c1.84-11.36,13.58-14.94,13.58-14.94-6.72-.19-18.83,8.31-18.83,8.31a20.67,20.67,0,0,0-5.78-4,13.9,13.9,0,0,1,1.93,3.47l-2.74.56c-3.47-8.11-8-11.67-18.61-12.35L300,323.06C294.87,332.35,292.88,351.45,318,355.77Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.61,326.33c15.41,12.07,49.5,26.08,49.5,26.08a29.51,29.51,0,0,0,2.44-23.51,32.12,32.12,0,0,0-2.44-5.58s-40.64-20.87-55-10.13C261.88,316.4,265.05,321.18,271.61,326.33Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.87,326.71c-6.52-14.74-26-5.37-32.54,3.32-7.08,9.39-2.62,23.69,8.22,23.57C359.62,353.49,380.7,339.9,374.87,326.71Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.27,348.6a10.67,10.67,0,0,0,9.28,5c6.35-.08,18.61-6.78,23.36-15.32,2-3.64,2.7-7.62,1-11.57-.07-.16-.15-.32-.23-.48a0,0,0,0,0,0,0,11.78,11.78,0,0,0-9.29-7.07c-8.24-1.16-18.58,5-23,10.89h0C337.93,335.87,338,343.61,341.27,348.6Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.61,326.33c15.41,12.07,49.5,26.08,49.5,26.08a29.51,29.51,0,0,0,2.44-23.51,31.59,31.59,0,0,1-10.06,2.44S292.79,315,279.87,317.6C276.24,318.34,273.25,321.75,271.61,326.33Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.43,342.38A356.58,356.58,0,0,0,325.19,357c8.6,3.14,14.55,5,14.55,5l3.63-8.25q-2.82-1-5.61-2.16a144,144,0,0,1-23.49-13.17c-22.68-15.21-41-32.8-49.16-24.24C257.1,322.56,271.93,333.25,290.43,342.38Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,349.18l-4.28,10.32s9.72,3.62,11.93,5.1c2.95,2,6,7.94,8.38,7.55s5.71-4.34,2.8-9.43-3.46-8.38-5.93-9.84-3.83-.13-8.28-1.2A24.05,24.05,0,0,1,334,349.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,362.79l.08-.05h0l.08,0h.08l.08,0c.09.07,1.77,1.49,1.83,2.8a1.36,1.36,0,0,1-.43,1.07c-.32.32-.63.42-.91.3s-.66-.95-.77-1.77a3.72,3.72,0,0,1-.9,1.81,1,1,0,0,1-.73.24.86.86,0,0,1-.82-.54,1.23,1.23,0,0,1,.07-.81A11.09,11.09,0,0,1,340,362.79Zm-.14.82c-1,1-2,2.41-1.83,2.93,0,0,.07.18.43.22a.49.49,0,0,0,.38-.14,2.22,2.22,0,0,0,.55-.92A10.8,10.8,0,0,0,339.87,363.61Zm1.82,2a3.93,3.93,0,0,0-1.28-2.11c0,1.42.23,2.86.6,3,.11.05.29-.1.39-.19a.88.88,0,0,0,.23-.36A1,1,0,0,0,341.69,365.6Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.43,342.38A356.58,356.58,0,0,0,325.19,357a105.78,105.78,0,0,0,12.57-5.37,144,144,0,0,1-23.49-13.17A84.5,84.5,0,0,0,290.43,342.38Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.93,346.37l1.59,8.87s29-1.43,53.75-6.64c13.52-2.84,25.75-6.82,31.22-12.3,2.78-2.79,3.82-6,2.38-9.59-.07-.16-.15-.32-.23-.48a0,0,0,0,0,0,0c-1.36-2.45-4.87-3-9.86-2.35-5.82.76-13.66,3.17-22.43,6.17C324.38,336.14,302.5,344.68,285.93,346.37Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.31,345.06,289.1,356s-10.33.94-12.85,1.78c-3.37,1.12-7.9,6.07-10.08,5.08s-4.36-5.69-.21-9.84,5.54-7.17,8.31-7.93,3.72.89,8.3,1A37.19,37.19,0,0,0,288.31,345.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.16,260.61c-7.84.28-21.37,14.14-28.5,17S296,261.56,296,261.56s1.13-4-4.64-7.32-7.23-4.53-8.21-1.49-1.92,6.95-.27,7.86,6.48,4.09,7.95,4.09c0,0,8.24,26.53,18.31,25.18s17.55-9.8,25.18-12.7Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,272.45a163.11,163.11,0,0,0-18.57-8.11c-5.18-1.83-16.43-4.36-21.61-4S311.05,276,311.05,276l6,12.47,4.63-2.46,8.39-4.33s-5.11,15-6.91,23.07l34.95,12.59s0-2.57,8.06-19.48c1.79-3.74,3.45-7.07,4.63-8.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.82,270.9s-10.84,5.41-19.36,3.39-9.39-12.3-9.39-12.3S356.2,261,370.82,270.9Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.48,231.28s-2.37-5.21-14.37-2.56S344,247.23,347,252.91s19.49,5.32,19.49,5.32l4-1.29s5.23-.89,6.36-12.66S372.48,231.28,372.48,231.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.75,234.81s.89-5.55,6.63-5.47,9.57,2.18,10.08,8.78-4.9,13-5.59,15.51,3.83,2.42,2.65,4.83-4.12,2.39-4.33,4,2.92,1.19,1.17,5.52-6.44,3.81-7,2.16,2.73-.91,1.17-3.46-3.84-2.13-2.21-5.75,1.73-5.36-1.55-8.2S371.75,234.81,371.75,234.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.46,281.24a4.52,4.52,0,0,1,1.32-.4c.27.06,1.55,7.64,2.55,9.48l-.88-.63.42,2.71a29.75,29.75,0,0,1-2-5.06l.42,2.09S357.71,283.31,357.46,281.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.28,286.82s7.58-4.33,7.87-4.1.26.91.32,1.26-5.07,2.79-6.86,3.68l.86-.66s-1.45.73-2.72,1.42a17,17,0,0,1,1.71-1.44l-1,.36s1-.82,2.21-1.57C357.71,285.77,356.53,286.22,355.28,286.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.84,289.48c-1.18,1.28-2.89,4.59-4.63,8.35-.86-8.3,4.2-15.1,4.2-15.1A13.93,13.93,0,0,0,370.84,289.48Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.62,271.71c-1.37,3.32-3.51,9.94-3.51,9.94L321.72,286C325.68,277.3,333.62,271.71,333.62,271.71Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,272.45c3.36,1.85,15.23,16,15.23,16l-12.45,11.4-11.26-10a38.79,38.79,0,0,1,1.38-11C371.42,274.1,377,272.45,377,272.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.36,259a8.51,8.51,0,0,0-2,3.13,38.2,38.2,0,0,0-1.92,7.32s-7.18,2-9.14.58-2.69-4.65-2.69-4.65a10.16,10.16,0,0,0,1.51-.69c4.12-2.26,2.76-5.69,2.76-5.69S370,256.7,367.36,259Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.36,259a8.51,8.51,0,0,0-2,3.13c-2.94,2.79-7.35,5.33-12.23,2.57a0,0,0,0,1,0,0c4.12-2.26,2.76-5.69,2.76-5.69S370,256.7,367.36,259Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.26,252.4c-1.06,4.64-3.85,8.72-8.52,10.26l-.65.19c-10.38,2.78-13.12-4.78-12.84-15.62.22-8.67,2.72-13.28,11.1-13.65C370.28,233.18,374.26,243.75,372.26,252.4Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.65,246.52a18.05,18.05,0,0,1-2.29,3.59,2.33,2.33,0,0,0,2.26.85Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,241.46a4.54,4.54,0,0,1-3.64-1.62.35.35,0,0,1,.08-.5.36.36,0,0,1,.51.08,4,4,0,0,0,3.24,1.31.36.36,0,0,1,.39.34.35.35,0,0,1-.33.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.48,240.9c-.23,0-.37,0-.39,0a.37.37,0,0,1,.13-.72,3.56,3.56,0,0,0,2.86-1.15.36.36,0,1,1,.5.53A4.54,4.54,0,0,1,351.48,240.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.15,247.29s-4.23-6.71-3.87-12c0,0-16.93-6-17,10.86,0,0-2.3-14.9,12.09-15.89s15.29,20.11,8.13,26.73C370.52,256.94,373.77,251.49,371.15,247.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.86,249.13a3.69,3.69,0,0,1,3.81-3.55c2.61.17,4.09,5.45-2.31,7C370.44,252.83,369.87,252,369.86,249.13Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.91,254.54a.29.29,0,0,1-.16,0,.36.36,0,0,1-.17-.48c1.11-2.27,3.7-2.15,4.92-1.77a.35.35,0,0,1,.23.45.36.36,0,0,1-.45.24c-.12,0-2.94-.88-4,1.39A.36.36,0,0,1,355.91,254.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.26,252.4c-1.06,4.64-3.85,8.72-8.52,10.26-.28-4.07,2.94-12.81,4.73-12.34A13.17,13.17,0,0,1,372.26,252.4Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.15,246c0,.69.37,1.25.83,1.24s.8-.57.8-1.26-.38-1.24-.83-1.23S360.15,245.26,360.15,246Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,245.58c0,.68.37,1.24.83,1.24s.81-.58.81-1.26-.38-1.24-.83-1.24S352,244.88,352,245.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.47,251.19c1.49-.68,5.22,2.1,5.6,2.77,1.07,1.89-1.19,7.6-1.19,7.6s22.55,23.42,23.3,32.32-13.46,3.21-13.46,3.21l1.79-1.64s-4.14-12.13-16-30.23c0,0-2.37-.61-3-2S367,251.88,368.47,251.19Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.75,251.63s-8.75-4.13-9.37-2.88,6.37,4,6.37,4Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.38,325.53H368.52l-.45,0a10.77,10.77,0,0,0-10.77,10.78v81.85h63.22V336.29A10.62,10.62,0,0,0,410.38,325.53Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.38,325.53H368.52l-.45,0a10.77,10.77,0,0,0-10.77,10.78v81.85h63.22V336.29A10.62,10.62,0,0,0,410.38,325.53Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.07,325.51h0a10.77,10.77,0,0,0-10.77,10.78v81.85h21.55V336.29A10.77,10.77,0,0,0,368.07,325.51Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trash-can--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.85,399.14a2.28,2.28,0,0,0-1.82-3.28,4.9,4.9,0,0,0-1.55-5.33,1.11,1.11,0,0,0-.67-.3,1.3,1.3,0,0,0-.73.32l-4.27,3.07a2.7,2.7,0,0,0-.85.83c-.87,1.7,2.28,3.86,1,5.26-.37.4-1,.48-1.43.77-1,.64-1.14,2-1.61,3.14s-2.13,1.95-2.76.93c.47-1.05-.95-2-2.09-2.1s-2.35-.19-3-1.27c-1.63,1.42-5.27-2.55-5.19-4.15a3.13,3.13,0,0,0-2.54,2.61,18.32,18.32,0,0,0-.14,4c0,2.59-.88,5.13-.83,7.72,0,2,.81,4.25,2.66,5.07a6.89,6.89,0,0,0,2.86.38l21-.13a3.35,3.35,0,0,0,1.48-.25c.95-.5,1.15-1.74,1.24-2.81q.56-6.84,1.13-13.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.85,399.14a2.28,2.28,0,0,0-1.82-3.28,4.9,4.9,0,0,0-1.55-5.33,1.11,1.11,0,0,0-.67-.3,1.3,1.3,0,0,0-.73.32l-4.27,3.07a2.7,2.7,0,0,0-.85.83c-.87,1.7,2.28,3.86,1,5.26-.37.4-1,.48-1.43.77-1,.64-1.14,2-1.61,3.14s-2.13,1.95-2.76.93c.47-1.05-.95-2-2.09-2.1s-2.35-.19-3-1.27c-1.63,1.42-5.27-2.55-5.19-4.15a3.13,3.13,0,0,0-2.54,2.61,18.32,18.32,0,0,0-.14,4c0,2.59-.88,5.13-.83,7.72,0,2,.81,4.25,2.66,5.07a6.89,6.89,0,0,0,2.86.38l21-.13a3.35,3.35,0,0,0,1.48-.25c.95-.5,1.15-1.74,1.24-2.81q.56-6.84,1.13-13.7Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.08,376.92H391.46l.27,3.29.19,2.36.5,6.12.29,3.52.37,4.68.16,2,.06.6.19,2.36.26,3.23.16,2,.17,2,.19,2.36.15,1.78.16,2,.07.87h29.93l.07-.87.16-2,.14-1.8.2-2.36.16-2,.17-2,.26-3.24.19-2.35,0-.6.16-2,.39-4.68.28-3.51.49-6.13.19-2.36.27-3.29Zm2,2.16h0l-.63-.63h.69Zm-.16,2-.06.8-2.92,2.92-3.35-3.35,3-3h.7ZM425,391.52l-2.14,2.14-3.35-3.35L422.9,387l2.31,2.31Zm-31-2.24h0l2.32-2.31,3.34,3.34-3.34,3.35-2.13-2.14Zm27.82-3.4-3.35,3.35-3.35-3.35,3.35-3.35Zm-5.26-7.43h3.83l-1.92,1.92Zm.82,11.86L414,393.66l-3.35-3.35L414,387Zm-11.12,4.43,3.35-3.35,3.34,3.35-3.34,3.34Zm2.26,4.43-3.35,3.34-3.34-3.34,3.35-3.35Zm5.52-3.35,3.34,3.35L414,402.51l-3.35-3.34Zm-4.43-6.59-3.35-3.35,3.35-3.35,3.34,3.35Zm-1.09,1.08-3.34,3.35-3.35-3.35,3.35-3.34Zm-7.77-1.08-3.35-3.35,3.35-3.35,3.34,3.35Zm0,2.16,3.34,3.35-3.34,3.34-3.35-3.34Zm3.34,12.21-3.34,3.34-3.35-3.34,3.35-3.35Zm1.08,1.08,3.35,3.35-3.34,3.35L401.83,408Zm1.09-1.08,3.35-3.35L413,403.6l-3.34,3.34Zm7.78,1.08,3.34,3.35L414,411.38,410.69,408Zm4.43,4.43,3.35,3.35-2.17,2.17h-2.36l-2.17-2.17Zm-3.35-5.51,3.35-3.35,3.35,3.35-3.35,3.34Zm0-8.86,3.35-3.35,3.35,3.35-3.35,3.34Zm2.26-13.29L414,384.8l-3.35-3.35,3-3h.7Zm-7.77-1.08-1.91-1.92h3.82Zm-1.09,1.08-3.34,3.35-3.35-3.35,3-3h.71Zm-5.86-3-1.91,1.92-1.91-1.92Zm-6,0,3,3-3.34,3.35-2.92-2.92-.06-.8,2.62-2.63Zm-2.87,0-.62.62h0l-.05-.62Zm-.2,5.79,1.64,1.64-1.4,1.39Zm.91,11.22-.13-1.58h0l.86.86-.73.72Zm.16,2,1.65-1.66,3.34,3.35-3.34,3.34L395,401.17Zm.5,6.19v-.14l.08.07-.07.07Zm.58,7.14-.42-5.14,1-1,3.34,3.35-3.34,3.34-.57-.56Zm.31,3.82-.07-.77.33-.32,1.08,1.09Zm1.34-2.17,3.35-3.35,3.34,3.35-2.16,2.17h-2.36Zm6.69,2.17,1.09-1.09,1.09,1.09Zm4.34,0-2.17-2.17,3.35-3.35,3.34,3.35-2.16,2.17Zm4.52,0,1.09-1.09,1.09,1.09Zm10.21,0h-1.35l1.09-1.09.32.32Zm.32-3.82-.58.56L419.55,408l3.35-3.35,1,1Zm.59-7.29,0,.15-.07-.07.09-.08Zm.19-2.35-1.36,1.34-3.35-3.34,3.35-3.35,1.66,1.66Zm.46-5.7-.74-.73.87-.86Zm.91-11.24-.25,3-1.4-1.4,1.65-1.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.08,376.92H391.46l.27,3.29.19,2.36.5,6.12.29,3.52.37,4.68.16,2,.06.6.19,2.36.26,3.23.16,2,.17,2,.19,2.36.15,1.78.16,2,.07.87h29.93l.07-.87.16-2,.14-1.8.2-2.36.16-2,.17-2,.26-3.24.19-2.35,0-.6.16-2,.39-4.68.28-3.51.49-6.13.19-2.36.27-3.29Zm2,2.16h0l-.63-.63h.69Zm-.16,2-.06.8-2.92,2.92-3.35-3.35,3-3h.7ZM425,391.52l-2.14,2.14-3.35-3.35L422.9,387l2.31,2.31Zm-31-2.24h0l2.32-2.31,3.34,3.34-3.34,3.35-2.13-2.14Zm27.82-3.4-3.35,3.35-3.35-3.35,3.35-3.35Zm-5.26-7.43h3.83l-1.92,1.92Zm.82,11.86L414,393.66l-3.35-3.35L414,387Zm-11.12,4.43,3.35-3.35,3.34,3.35-3.34,3.34Zm2.26,4.43-3.35,3.34-3.34-3.34,3.35-3.35Zm5.52-3.35,3.34,3.35L414,402.51l-3.35-3.34Zm-4.43-6.59-3.35-3.35,3.35-3.35,3.34,3.35Zm-1.09,1.08-3.34,3.35-3.35-3.35,3.35-3.34Zm-7.77-1.08-3.35-3.35,3.35-3.35,3.34,3.35Zm0,2.16,3.34,3.35-3.34,3.34-3.35-3.34Zm3.34,12.21-3.34,3.34-3.35-3.34,3.35-3.35Zm1.08,1.08,3.35,3.35-3.34,3.35L401.83,408Zm1.09-1.08,3.35-3.35L413,403.6l-3.34,3.34Zm7.78,1.08,3.34,3.35L414,411.38,410.69,408Zm4.43,4.43,3.35,3.35-2.17,2.17h-2.36l-2.17-2.17Zm-3.35-5.51,3.35-3.35,3.35,3.35-3.35,3.34Zm0-8.86,3.35-3.35,3.35,3.35-3.35,3.34Zm2.26-13.29L414,384.8l-3.35-3.35,3-3h.7Zm-7.77-1.08-1.91-1.92h3.82Zm-1.09,1.08-3.34,3.35-3.35-3.35,3-3h.71Zm-5.86-3-1.91,1.92-1.91-1.92Zm-6,0,3,3-3.34,3.35-2.92-2.92-.06-.8,2.62-2.63Zm-2.87,0-.62.62h0l-.05-.62Zm-.2,5.79,1.64,1.64-1.4,1.39Zm.91,11.22-.13-1.58h0l.86.86-.73.72Zm.16,2,1.65-1.66,3.34,3.35-3.34,3.34L395,401.17Zm.5,6.19v-.14l.08.07-.07.07Zm.58,7.14-.42-5.14,1-1,3.34,3.35-3.34,3.34-.57-.56Zm.31,3.82-.07-.77.33-.32,1.08,1.09Zm1.34-2.17,3.35-3.35,3.34,3.35-2.16,2.17h-2.36Zm6.69,2.17,1.09-1.09,1.09,1.09Zm4.34,0-2.17-2.17,3.35-3.35,3.34,3.35-2.16,2.17Zm4.52,0,1.09-1.09,1.09,1.09Zm10.21,0h-1.35l1.09-1.09.32.32Zm.32-3.82-.58.56L419.55,408l3.35-3.35,1,1Zm.59-7.29,0,.15-.07-.07.09-.08Zm.19-2.35-1.36,1.34-3.35-3.34,3.35-3.35,1.66,1.66Zm.46-5.7-.74-.73.87-.86Zm.91-11.24-.25,3-1.4-1.4,1.65-1.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 389.38,
    y: 375.55,
    width: 40.46,
    height: 4.27,
    rx: 1.64,
    transform: "translate(819.22 755.37) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.29,
    y: 413.87,
    width: 34.63,
    height: 4.27,
    rx: 1.64,
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.cb6bbf0c2a1bd5e87f1878e35ec451dd.svg";
export { ForwardRef as ReactComponent };